import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import RoomForm from './Form';
import { findRoomById, mutation } from '../../../shared/queries/Room';

const RoomFormHandler = ({ match, t, history, dispatch }) => {
  const [dto, setDto] = useState({ id: 0, active: true });
  const [formOn, setFormOn] = useState(false);

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const backClickHandler = () => {
    history.push('/minime/sala');
  };

  const handleSubmit = (values) => {
    showLoading();
    const mutationQuery = mutation(values);
    GraphQL(mutationQuery, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        backClickHandler();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const findById = (id) => {
    showLoading();
    const getItemByIdQuery = findRoomById(id);
    GraphQL(getItemByIdQuery, {})
      .then((res) => {
        if (res.roomListByFilter) {
          setDto(res.roomListByFilter[0]);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <>
      {formOn && (
        <RoomForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dispatch={dispatch}
          dto={dto}
        />
      )}
    </>
  );
};

RoomFormHandler.propTypes = {
  dispatch: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(RoomFormHandler)
);
